import { useNavigate } from 'react-router-dom';
import styles from './HomePage.module.css';
import aboutUsImage from '../../assets/about-us-image.png';
import modernArchitectureImage from '../../assets/modern-architecture.png'; // <-- NEW IMAGE IMPORT

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.homePage}>
      <div className={styles.backgroundText}>NATE~ANNE</div>
      
      {/* Hero Section */}
      <header className={styles.hero}>
        <h1 className={styles.heroTitle}>Building the Digital Future of Your Business</h1>
        <p className={styles.heroSubtitle}>
          From elegant designs to powerful back-end systems, we create bespoke web solutions that deliver results.
        </p>
        <button onClick={() => navigate('/contact')} className={styles.ctaButton}>Get a Free Consultation</button>
      </header>
      <section className={styles.imageContentSection}>
        <img src={modernArchitectureImage} alt="Modern web architecture" className={styles.fullWidthImage} />
        <div className={styles.imageOverlayText}>
          <h3>Crafting Seamless Digital Experiences</h3>
          <p>Where innovation meets intuitive design.</p>
        </div>
      </section>
      <section className={styles.services}>
        <h2 className={styles.sectionTitle}>What We Do</h2>
        <div className={styles.servicesGrid}>
          <div className={styles.serviceCard}>
            <h3>Full-Stack Development</h3>
            <p>We build your entire digital presence from the ground up. From the beautiful website your customers see (front-end) to the powerful engine that runs it (back-end & databases), we handle everything.</p>
          </div>
          <div className={styles.serviceCard}>
            <h3>Graphic & UI/UX Design</h3>
            <p>A great product needs a great design. We craft intuitive and beautiful user interfaces that make your brand stand out and are a joy for your customers to use.</p>
          </div>
          <div className={styles.serviceCard}>
            <h3>SEO & Digital Strategy</h3>
            <p>We build websites that are optimized for search engines from day one, helping you rank higher on Google and attract more organic traffic to your business.</p>
          </div>
          <div className={styles.serviceCard}>
            <h3>Platform Expertise</h3>
            <p>Whether you need a powerful online store with Shopify or a quick, stunning site using Framer or Wix, we choose the right tool for your project and budget.</p>
          </div>
        </div>
      </section>
      <section className={styles.aboutSection}>
        <div className={styles.aboutGrid}>
            <div className={styles.aboutImageContainer}>
                <img src={aboutUsImage} alt="Symbol of partnership and trust" className={styles.aboutImage} />
            </div>
            <div className={styles.aboutContent}>
                <h2 className={styles.sectionTitle}>Who We Are</h2>
                <p>
                    As a family-owned business, integrity and quality are not just buzzwords; they are the pillars of our work. Our mission is to do our absolute best to ensure every client is delighted with the results. We believe in building lasting partnerships, and that starts with being accessible. We're always just one email, text, or call away, ready to support you on your journey.
                </p>
            </div>
        </div>
      </section>
      <section className={styles.testimonialsSection}>
        <h2 className={styles.sectionTitle}>What Our Clients Say</h2>
        <div className={styles.testimonialsGrid}>
          <div className={styles.testimonialCard}>
            <p>"Nate~Anne transformed our online presence. Their attention to detail and proactive communication made the entire process seamless. Highly recommended!"</p>
            <h4>— Leeroy, CEO of Leeway Motors</h4>
          </div>
          <div className={styles.testimonialCard}>
            <p>"Professional, reliable, and truly invested in our success. Nate~Anne delivered a website that exceeded our expectations and perfectly captured our brand."</p>
            <h4>— Edward, Founder of Wardmac</h4>
          </div>
          <div className={styles.testimonialCard}>
            <p>"From concept to launch, the team at Nate~Anne was exceptional. They brought our vision to life with precision and creativity. A genuine pleasure to work with."</p>
            <h4>— David, Director & Founder of Hope For All</h4>
          </div>
        </div>
      </section>
      <section className={styles.processSection}>
        <h2 className={styles.sectionTitle}>Our Transparent Process</h2>
        <div className={styles.processGrid}>
          <div className={styles.processStep}>
            <span className={styles.stepNumber}>01</span>
            <h3>Discovery & Planning</h3>
            <p>We start by understanding your vision, goals, and target audience to craft a tailored strategy.</p>
          </div>
          <div className={styles.processStep}>
            <span className={styles.stepNumber}>02</span>
            <h3>Design & Development</h3>
            <p>Bringing your ideas to life with elegant design and robust, scalable code.</p>
          </div>
          <div className={styles.processStep}>
            <span className={styles.stepNumber}>03</span>
            <h3>Testing & Launch</h3>
            <p>Rigorous testing ensures flawless performance before a successful, impactful launch.</p>
          </div>
          <div className={styles.processStep}>
            <span className={styles.stepNumber}>04</span>
            <h3>Support & Growth</h3>
            <p>Ongoing support and strategic guidance to ensure your digital presence continues to thrive.</p>
          </div>
        </div>
      </section>
      <section className={styles.ctaBanner}>
        <div className={styles.ctaContent}>
          <h2>Ready to Start Your Next Project?</h2>
          <p>Let's turn your ideas into a powerful online reality. Contact us today for a free consultation.</p>
          <button onClick={() => navigate('/contact')} className={styles.ctaButton}>Get a Quote</button>
        </div>
      </section>


    </div>
  );
};

export default HomePage;